import i18n from "i18next"
import LanguageDetector from "i18next-browser-languagedetector"
import Backend from "i18next-locize-backend"
import HttpBackend from "i18next-http-backend"
import ChainedBackend from "i18next-chained-backend"
import { initReactI18next } from "react-i18next"

export const initI18n = (sasToken) => {
  const locizeOptions = {
    projectId: "b86c695c-62be-4454-bd14-e4b2f05a1dbd",
    apiKey: "9bee6b7e-55fe-46ce-a5e5-f1fa7bf8fdc0",
    referenceLng: "en",
    loadPath: "https://api.locize.app/b86c695c-62be-4454-bd14-e4b2f05a1dbd/version1/{{lng}}/latest"
  }

  const backends = [Backend]
  const backendOptions = [locizeOptions]

  if (sasToken) {
    //change this url depending on what environment you are in
    // DEV: const azureLoadPath = `https://clpdev.blob.core.windows.net/translations/version1-{{lng}}.json?${sasToken}`
    const azureLoadPath = `https://clpcompanyportalprod.blob.core.windows.net/translations/version1-{{lng}}.json?${sasToken}`

    const httpBackendOptions = {
      loadPath: azureLoadPath,
      requestOptions: {
        cache: "no-store"
      }
    }

    backends.push(HttpBackend)
    backendOptions.push(httpBackendOptions)
  }

  return i18n
    .use(ChainedBackend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      debug: false,
      fallbackLng: "en",
      interpolation: { escapeValue: false },
      backend: {
        backends,
        backendOptions
      }
    })
}
